<template>
	<Panel hasShadow :contentPaddingBottom="24" class="mb-16">
		<div class="flex-row cursor-pointer flex-row-center-between">
			<div class="flex-row">
				<p class="color-gy-9 mr-4 font-h2-medium">待办事项</p>
				<Explain icon="icon-a-help-circlebangzhu-mian" :content="tipContent" placement="top" :size="iconSize" class="cursor-pointer"></Explain>
			</div>
		</div>
		<div class="itemStyle flex flex-wrap">
			<div class="mt-24 flex-column" v-for="item in todoList" :key="item.key" style="width: 50%">
				<span class="font-h6-regular yx-color-text-secondary cursor-pointer" @click="skipUrl(item.url)">
					{{ item.title }}
					<i class="el-icon-arrow-right"></i>
				</span>
				<div>
					<i v-if="item.loadkey" class="el-icon-loading fz-24 yx-color-primary"></i>
					<span v-else class="fz-18 color-gy-9 Barlow-Bold">
						{{ item.value }}
					</span>
				</div>
			</div>
		</div>
	</Panel>
</template>

<script>
import Explain from '@/components/common/explain';
import { debounce } from 'lodash';
import { deliveryStatus } from '@/utils/dataMap';
import { getHomeWorkBench } from '@/api/home';

export default {
	props: {
		platformId: {
			type: [Number, String],
			default: null,
		},
		userIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		deptIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		authorityId: {
			type: [Number, String],
			default: null,
		},
		params: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			iconSize: 20,
			todoList: [],
			todoListMap: new Map([
				['noDelivery', { title: '待发货样品', value: 0, loadkey: false, url: '/sample/list?delivery_status=' + deliveryStatus.notShipped }],
				['arrival', { title: '运输中样品', value: 0, loadkey: false, url: '/sample/list?delivery_status=' + deliveryStatus.transit }],
				['noConfirm', { title: '到货未确认商品', value: 0, loadkey: false, url: '/sample/list?delivery_status=' + deliveryStatus.arrived }],
				['noUploadUrl', { title: '未上传带货链接', value: 0, loadkey: false, url: '/cooperationProgress/list?tabid=2&other_status=500' }],
				['uncheckUrl', { title: '未校验带货链接', value: 0, loadkey: false, url: '/cooperationProgress/list?tabid=2&other_status=501' }],
				['waitLiveCount', { title: '待交付合作', value: 0, loadkey: false, url: '/cooperationProgress/list?tabid=2' }],
			]),
		};
	},
	created() {
		this.tipContent =
			'待发货样品：处于待发货状态的样品订单，需要补充物流信息进行发货\n' +
			'运输中样品：处于运输中状态的样品订单\n' +
			'到货未确认商品：已到货还未确认带货的商品数量，需要跟进达人是否确认带货\n' +
			'未上传带货链接：确认带货还未上传带货链接的商品数量，需要招商运营补充让达人上橱窗的带货链接\n' +
			'未校验带货链接：已上传带货链接还未进行校验的商品数量，需要跟进达人确认链接/机制等是否正确\n' +
			'待交付合作：处于待交付状态的合作进度，等待达人交付履约';
	},
	computed: {
		searchParameters() {
			return {
				platform_id: this.platformId,
				deptIds: this.deptIds,
				userIds: this.userIds,
				startTime: this.params.from_time,
				endTime: this.params.to_time,
				authority_id: this.authorityId,
			};
		},
	},
	watch: {
		searchParameters: {
			handler() {
				this.getData();
			},
			deep: true,
		},
	},
	methods: {
		async getData() {
			this.todoListMap.forEach((value, key) => {
				this.todoListMap.set(key, { ...value, key });
			});
			this.todoList = [...this.todoListMap.values()];
			try {
				this.todoListMap.forEach((value, key) => {
					value.loadkey = true;
					this.todoListMap.set(key, value);
				});
				const { data } = await getHomeWorkBench({ ...this.searchParameters });
				Object.entries(data).map(([key, value]) => {
					this.todoListMap.get(key).value = value;
					this.todoListMap.get(key).loadkey = false;
				});
				this.todoList = [...this.todoListMap.values()];
			} finally {
				this.todoListMap.forEach((value, key) => {
					value.loadkey = false;
					this.todoListMap.set(key, value);
				});
				this.todoList = [...this.todoListMap.values()];
			}
		},
		skipUrl(url) {
			const handLink = this.$router.resolve({
				path: url,
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .panel-body {
	padding: 0 0 0 24px;
}
</style>
